/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Driverremittance_Receive_At_Future1Inputs */

const vi_driverremittance_receive_at_future1 = /** @type {(inputs: Driverremittance_Receive_At_Future1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngày giờ nhận tiền không được ở tương lai.`)
};

/**

* @param {Driverremittance_Receive_At_Future1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const driverremittance_receive_at_future1 = /** @type {((inputs?: Driverremittance_Receive_At_Future1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Driverremittance_Receive_At_Future1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_driverremittance_receive_at_future1(inputs)
});
export { driverremittance_receive_at_future1 as "driverRemittance_receive_at_future" }